module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-search-input', {
    attrs: {
      "display-in-browser": _vm.displayInBrowser
    },
    on: {
      "updateSearchKeyword": _vm.handleFilter
    }
  }), _vm._v(" "), (_vm.memberList && _vm.memberList.length > 0) ? _c('div', [_c('gc-single-selection', {
    attrs: {
      "member-list": _vm.memberList
    },
    on: {
      "updateSelection": _vm.handleUpdateSelection
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f93804c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/components/GcOrderSearchBox.vue
// module id = 1671
// module chunks = 8